let inject = ['$scope', '$uibModalInstance'];

class PqrsDetailModalController {
  constructor ($scope,$uibModalInstance) {
    this.$scope = $scope;
    this.$uibModalInstance = $uibModalInstance;
    this.comment = '';
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }

  ok() {
    this.$uibModalInstance.close(this.comment);
  }
}

PqrsDetailModalController.$inject = inject;

export default PqrsDetailModalController;



/** WEBPACK FOOTER **
 ** ./www/components/pqrs/pqrs-detail/pqrs-detail-modal/pqrs-detail-modal.controller.js
 **/